import React, { useState, useEffect } from "react";

import styled from "styled-components";

function Input(props) {
  return (
    <>
      <InputWrapper
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={props.onChange}
        type={props.type}
        placeholder={props.placeholder}
        style={{
          ...props.style,
        }}
        onKeyDown={props.onKeyDown}
        maxLength={props.maxLength}
        disabled={props.disabled}
        onClick={props.onClick}
        autoComplete={props.autocomplete}
      />
    </>
  );
}

export default Input;

const InputWrapper = styled.input.attrs((props) => {})`
  width: 100%;
  box-sizing: border-box;

  height: 56px;
  padding: 17px 15px;

  background: #ffffff;
  font-family: LINESeedKR-Rg;
  font-size: 16px;
  font-weight: 400;
  color: #101113;
  border: 1px solid #dbdde0;
  border-radius: 12px;

  &::placeholder {
    font-family: LINESeedKR-Rg;
    font-size: 16px;
    font-weight: 400;
    color: #a4a8b1;
  }

  &:focus {
    outline: none !important;
    border-color: #5050ff !important;
  }

  &:disabled {
    outline: none;
    background: #f5f5f5;
    color: #ababab;
  }
`;
